import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'
import { Suspense } from 'react'
import { useLocale } from 'react-intlayer'
import { productsAtom } from '@/atoms/input.atom'
import { type SupportKind, SupportView } from '@/components/support-view'
import { client } from '@/lib/client'

export const Route = createFileRoute('/support/$slug/')({ component: Page })
function Page() {
  const { locale } = useLocale()
  const { slug } = Route.useParams()
  const language = locale === 'en' ? 'en' : 'ja'
  if (!['bug_report', 'feature_request', 'suggestion'].includes(slug)) {
    return (
      <div>
        <h1>{language === 'ja' ? 'お問い合わせの種類が見つかりません' : 'Contact option not found'}</h1>
        <a href='/support'>{language === 'ja' ? 'お問い合わせ一覧へ' : 'All contact options'}</a>
      </div>
    )
  }
  return (
    <Suspense fallback={<p role='status'>{language === 'ja' ? 'フォームを読み込んでいます…' : 'Loading the form…'}</p>}>
      <SupportForm key={slug} kind={slug as SupportKind} locale={language} />
    </Suspense>
  )
}

function SupportForm({ kind, locale }: { kind: SupportKind; locale: 'ja' | 'en' }) {
  const { data: products } = useAtomValue(productsAtom)
  const navigate = useNavigate()
  return (
    <SupportView
      screen='form'
      kind={kind}
      locale={locale}
      products={products.map((product) => product.trackName)}
      onBack={() => {
        void navigate({ to: '/support' })
      }}
      onSubmit={async (data) => {
        await client.post('/submit', data)
        await navigate({ to: '/support/success', replace: true })
      }}
    />
  )
}
